export default __webpack_public_path__ + "static/media/payment-success.abaa10f8.svg";